import { FormControl, ValidatorFn } from "@angular/forms";
import { isArray } from "ngx-bootstrap/chronos";

export function checkFieldsArray(field: string, requiredValues: string[]): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } => {
        if (!control.value || !isArray(control.value)) {
            return null;
        }

        let countRequired = 0;
        for (const key in control.value) {
            if (control.value) {
                const element = control.value[key];
                if (!!element[field] && requiredValues.includes(element[field])) {
                    countRequired++;
                }
            }
        }

        if (requiredValues.length !== countRequired) {
            return { fieldNotFound: true };
        }

        return null;
    };
}
